import React from "react"
import "../../App.less"

export default function CloseButton({
  className = "closeIconModalPC",
  ...props
}) {
  return (
    <div className={className} onClick={props.onClick}>
      X
    </div>
  )
}
